import { render, staticRenderFns } from "./return-edit.component.vue?vue&type=template&id=72456759&scoped=true"
import script from "./return-edit.component.vue?vue&type=script&lang=ts"
export * from "./return-edit.component.vue?vue&type=script&lang=ts"
import style0 from "./borrowing.style.scss?vue&type=style&index=0&id=72456759&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72456759",
  null
  
)

export default component.exports